const firebaseConfig = {
    apiKey: "AIzaSyAnNiZzYGAj9q2DN_5Jn6xub-lrxI5f-zg",
    authDomain: "riders-planet-20505.firebaseapp.com",
    projectId: "riders-planet-20505",
    storageBucket: "riders-planet-20505.appspot.com",
    messagingSenderId: "56797413469",
    appId: "1:56797413469:web:69c2dc0ca6af7d60114db4"
  };
   export default firebaseConfig;